import { checkDiff } from '../../../utils/formValidation/errorCheckingFunctions';
import { getMultiSelectMessage } from '../../../utils/formValidation/errorMessageFunctions';

export const validate = (preSelectedIds, selectedIds) => {
    let newErrors = {};

    if (!selectedIds?.length) {
        newErrors = {
            actionPlanStatusIds: {
                error: true,
                message: getMultiSelectMessage('action plan status outcome')
            }
        };
    }

    if (Object.keys(newErrors).length < 1) {
        newErrors = checkDiff(preSelectedIds, selectedIds);
    }

    return newErrors;
};
